export const CURRENCY_TO_COUNTRY_MAP: Record<string, string> = {
  TND: 'Tunisia',
  DZD: 'Algeria',
  MAD: 'Morocco',
  ZAR: 'South Africa',
  XOF: 'Senegal'
}

export const getCountryFromCurrency = (
  currencyCode: string | null
): string | null => {
  if (!currencyCode) return null
  let cleanCurrencyCode = currencyCode
  try {
    if (currencyCode.startsWith('"') && currencyCode.endsWith('"')) {
      cleanCurrencyCode = JSON.parse(currencyCode)
    }
  } catch (error) {
    console.warn(error)
    cleanCurrencyCode = currencyCode
  }

  return CURRENCY_TO_COUNTRY_MAP[cleanCurrencyCode] || null
}

export const TARGET_COUNTRIES = Object.values(CURRENCY_TO_COUNTRY_MAP)
